export const search_list = [
  {
	type: "input",
	label: "公告标题",
	props: "title",
  },
  
];
export const tableColumns = [
  {
    title: "公告标题",
    value: "title",
    header_align: "center",
    align: "center",
    width: 220,
  },
  {
    title: "公告内容",
    value: "content_text",
    header_align: "center",
    align: "center",
    width: 360,
  },
  {
    title: "创建日期",
    value: "created_at",
    header_align: "center",
    align: "center",
    width: 180,
  },
  {
    title: "公告状态",
    value: "status_text",
    header_align: "center",
    align: "center",
    width: 100,
  }
];

export const actionGroup = [
  {
    name: "删除",
    is_delete: true,
    flag: "delete",
    status: "danger",
  },
  {
    name: "编辑",
    flag: "edit",
    rules: "",
  },
  {
    name: "详情",
    flag: "detail",
    rules: "",
  }
];
